<template>
    <li class="has-sub">
        <a href="javascript:;">
            <b class="caret pull-right"></b>
            <i class="fa fa-cog"></i>
            <span>OSS Configs</span>
        </a>

        <ul class="sub-menu">
            <li>
                <router-link to="/landing-packages"
                    >Paket Landing Page</router-link
                >
            </li>
            <li>
                <router-link to="/landing-banners"
                    >Banner Landing Page</router-link
                >
            </li>
            <li>
                <router-link to="/android-banners">Banner Android</router-link>
            </li>
            <li>
                <router-link to="/webapp-banners">Banner Webapp</router-link>
            </li>
        </ul>
    </li>
</template>

<script>
export default {
    name: "oss-nav",
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?2e4c682f